import React, { useEffect, useContext } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useReservation } from '../../Common/Context/ReserveContextV2';
import MonthlyImage from '../Views/MonthlyImage';
import { SalesRootContext } from '../../Common/Context/SalesRootContext';
import '../../css/Confirmed.css'

const Confirmed = () => {
    const { isReserved, setIsReserved } = useReservation();
    const { salesRootData } = useContext(SalesRootContext);
    const navigate = useNavigate();
    const location = useLocation();

    const { selectedRoot, TLAP_id, TLAP_name, company } = salesRootData;
    const appointment_date = location.state?.appointment_date || salesRootData.appointment_date;

    // ここで渡された予約確定時間などの情報を受け取る
    const appointmentTime = location.state ? location.state.appointment_time : null;
    const confirmedTime = appointmentTime ? new Date(appointmentTime) : null;

    useEffect(() => {
        setIsReserved(false);
    }, [setIsReserved]);

    // カレンダーページに戻る関数
    const backCalendar = () => {
        navigate('/carendar', {
            state: {
                isReserved: false, // 明示的にfalseに設定
                selectedRoot,
                TLAP_id,
                TLAP_name,
                company
            }
        });
    };

    if (!confirmedTime) {
        return <div>予約情報がありません。</div>;
    }

    function formatAppointmentDate(dateStr) {
        const year = dateStr.substring(0, 4);
        const month = dateStr.substring(4, 6);
        const day = dateStr.substring(6, 8);
        const hour = dateStr.substring(8, 10);
        return `${year}/${month}/${day} ${hour}:00`;
    }

    return (
        <div className='wrapper confirmed'>
            <div className="confetti">
                <span></span><span></span><span></span>
                <span></span><span></span><span></span>
                <span></span><span></span>
            </div>
            <h1 className='caution'>※変更点はすぐにSVまで！※</h1>
            <div className='article'>
                <p>予約が確定しました！</p>
                <div className="appointment-info">
                    <table>
                        <tbody>
                            <tr>
                                <th>アポイント日</th>
                                <td>{formatAppointmentDate(appointment_date)}</td>
                            </tr>
                            <tr>
                                <th>確定時間</th>
                                <td>{confirmedTime && new Date(confirmedTime).toLocaleString()}</td>
                            </tr>
                            <tr>
                                <th>営業ルート</th>
                                <td>{selectedRoot}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <button onClick={backCalendar} className='backCalender buttonStyle'>カレンダーに戻る</button>
            <div className='flexB congratulations-wrapper'>
                <MonthlyImage />
                <div>
                    <div className='box'>
                        <p>＼おめでとう{TLAP_name}さん！／</p>
                        <p>ありがとう！この調子で頑張ろう！</p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Confirmed;
